module.exports = __webpack_public_path__ + "img/askmebet-support.31925405.png";